
import Vue, { PropType } from 'vue'

interface LinkItem {
  title: string;
  code: string;
  children: LinkItem[];
  isUrl?: boolean;
}

export default Vue.extend({
  name: 'BottomHeaderMenu',
  props: {
    /**
     * Массив деревьев ссылок
     */
    links: {
      type: Array as PropType<LinkItem[]>,
      required: true,
      default: () => []
    },
    /**
     * Код текущего корневого роута
     */
    currentRouteCode: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    showedLinks () {
      const showedLinks = [...(this.links?.filter(link => link.showInMenu) || [])]

      return showedLinks.sort((a, b) => (a?.sortInMenu || 0) - (b?.sortInMenu || 0))
    },
    unShowedLinks () {
      return this.links?.filter(link => !link.showInMenu) || []
    },
    visibleLinks () {
      return this.showedLinks?.slice(0, 4) || []
    },
    hiddenLinks () {
      return [...(this.showedLinks?.slice(4) || []), ...this.unShowedLinks].sort((a, b) => (a?.sortInMenu || 0) - (b?.sortInMenu || 0))
    }
  }
})
